(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawl-rail-photo-pair"] && !Shopify.designMode) return;
  try {
    document.addEventListener('error', event => {
    const image = event.target;
    if (image instanceof HTMLImageElement && image.hasAttribute('data-rail-print-patch')) image.hidden = true;
  }, true);
  document.querySelectorAll('[data-rail-print-patch]').forEach(image => {
    if (image.complete && !image.naturalWidth) image.hidden = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pawl-winter-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('details[data-pawl-winter-sizing][open]').forEach((guide) => {
      if (!guide.contains(event.target)) guide.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const guide = event.target.closest('details[data-pawl-winter-sizing][open]');
    if (!guide) return;
    guide.open = false;
    guide.querySelector('summary')?.focus();
    event.preventDefault();
  });
  } catch(e) { console.error(e); }
})();

})();
